import styles from './TextSeparator.module.scss'

export const TextSeparator = () => <span className={styles.Separator}>|</span>
